/**
 * Ca công trình của tổ trưởng — docs/02 §2.4.
 *
 * Tổ trưởng mở một ca tại công trình, máy sinh mã 6 số xoay vòng (TOTP từ
 * `totp_secret`, tính offline bằng `lib/totp.ts`). Thợ quét mã hoặc gõ số để
 * chấm công khi máy họ không có cách nào khác chứng minh vị trí.
 *
 * TOTP tính ngay trên máy tổ trưởng chứ không hỏi server từng mã: ở công
 * trường mất sóng, hỏi server là mất luôn cả phương án dự phòng này.
 */

import { request } from '../api/client'
import type { CaCongTrinh } from '../types'

export const moCaCongTrinh = (site_id: number) =>
  request<CaCongTrinh>('/site-sessions/open', {
    method: 'POST', body: JSON.stringify({ site_id }),
  })

export const layCaDangMo = () =>
  request<{ date: string; items: Array<CaCongTrinh & { so_luot_cham: number }> }>(
    '/site-sessions/open')

export const layMaCa = (id: number) =>
  request<CaCongTrinh & { expires_in: number }>(`/site-sessions/${id}/qr`)

export const dongCaCongTrinh = (id: number) =>
  request<{ ok: true }>(`/site-sessions/${id}/close`, { method: 'POST' })
